import React from 'react';
import {
    Button,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    InputLabel,
    MenuItem,
    Paper,
    Radio,
    RadioGroup,
    Select,
    Snackbar,
    TextField,
    Typography
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import MuiAlert from "@material-ui/lab/Alert";
import { useEffect, useState } from "react";
import axios from "src/utils/axios";
import logger from 'src/utils/logger';

// Sunucudan gelen response key'lerini büyük harfe dönüştüren yardımcı fonksiyon
const normalizeKeys = (obj) => {
    if (Array.isArray(obj)) {
        return obj.map(item => normalizeKeys(item));
    }
    if (obj !== null && typeof obj === 'object') {
        return Object.keys(obj).reduce((acc, key) => {
            const upperKey = key.toUpperCase();
            acc[upperKey] = normalizeKeys(obj[key]);
            return acc;
        }, {});
    }
    return obj;
};

const BodForm = (props) => {
    const fisNoParam = props?.match?.params?.fisNo;
    const pathParts = window.location.pathname.split("/");
    const fisNoPath = pathParts[pathParts.length - 1];

    const rawFisNo = fisNoParam || fisNoPath || "";
    const isDummyFis = String(rawFisNo) === "1";// Gelen değer "1" ise yok say (Null muamelesi yap)
    const isUrlHasFis = rawFisNo && !isNaN(rawFisNo) && !isDummyFis; // Değer boş değilse, sayıysa VE "1" değilse -> URL'de Fiş Var demektir
    const effectiveFisNo = isUrlHasFis ? rawFisNo : ""; // Eğer URL'de geçerli bir fiş varsa (1 hariç) onu kullan, yoksa boş string ata
    const [errors, setErrors] = useState({});

    const [entryType, setEntryType] = useState("FIS");

    const [form, setForm] = useState({
        FIS_NO: effectiveFisNo, // URL'de geçerli fiş varsa dolar, "1" geldiyse boş kalır
        PAKET_NO: "",
        TUKETICI_AD_SOYAD: "",
        TUKETICI_TELEFON: "",
        KUL_BAYI_KODU: "",
        KUL_MODEL_KODU: "",
        UYIL: new Date().getFullYear(),
        UDONEM: new Date().getMonth() + 1,
        SERI_NO: null,
        NITELIK_KODU: null,
        ACIKLAMA: "",
        BOD_ADI: "",
        BOD_CALISAN_AD_SOYAD: "",
        BOD_ARAC_PLAKA: "",
        NAKLIYE_MONTAJ_FIS_NO: null,
    });

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });

    const [allBayiler, setAllBayiler] = useState([]);
    const [allModeller, setAllModeller] = useState([]);
    const [filteredBayiler, setFilteredBayiler] = useState([]);
    const [filteredModeller, setFilteredModeller] = useState([]);

    const [bodList, setBodList] = useState([]);

    const [bayiSearch, setBayiSearch] = useState("");
    const [modelSearch, setModelSearch] = useState("");
    const [selectedModelMarka, setSelectedModelMarka] = useState(null);

    const resetForm = () => {
        setForm({
            FIS_NO: effectiveFisNo,
            PAKET_NO: "",
            TUKETICI_AD_SOYAD: "",
            TUKETICI_TELEFON: "",
            KUL_BAYI_KODU: "",
            KUL_MODEL_KODU: "",
            UYIL: new Date().getFullYear(),
            UDONEM: new Date().getMonth() + 1,
            SERI_NO: null,
            NITELIK_KODU: null,
            ACIKLAMA: "",
            BOD_ADI: "",
            BOD_CALISAN_AD_SOYAD: "",
            BOD_ARAC_PLAKA: "",
            NAKLIYE_MONTAJ_FIS_NO: null,
        });


        setBayiSearch("");
        setModelSearch("");
        setSelectedModelMarka(null);
        setErrors({});

        if (!isUrlHasFis) {
            setEntryType("FIS");
        }
    };

    useEffect(() => {
        const loadDefinitions = async () => {
            const CACHE_KEY = "bod_definitions";
            const CACHE_DURATION = 1000 * 60 * 60;

            const cachedData = localStorage.getItem(CACHE_KEY);
            let parsedData = null;

            if (cachedData) {
                const item = JSON.parse(cachedData);
                const now = new Date().getTime();
                if (now - item.timestamp < CACHE_DURATION) {
                    // Cache'den okunan veriyi de normalize et
                    parsedData = normalizeKeys(item.data);
                }
            }

            if (parsedData) {
                setAllBayiler(parsedData.BAYILER || []);
                setAllModeller(parsedData.MODELLER || []);
            } else {
                try {
                    const res = await axios.get("GetAllBayiModel");
                    const rawData = res.data;
                    const data = normalizeKeys(rawData);
                    if (data) {
                        setAllBayiler(data.BAYILER || []);
                        setAllModeller(data.MODELLER || []);
                        const cacheObject = {
                            data: { BAYILER: data.BAYILER, MODELLER: data.MODELLER },
                            timestamp: new Date().getTime()
                        };
                        localStorage.setItem(CACHE_KEY, JSON.stringify(cacheObject));
                    }
                } catch (err) {
                    logger.error("Tanımlamalar yüklenirken hata:", err);
                }
            }
        };
        loadDefinitions();
    }, []);

    useEffect(() => {
        let params = {};

        if (effectiveFisNo && effectiveFisNo !== "1" && effectiveFisNo !== "0") {
            params.fisNo = effectiveFisNo;
        }

        axios
            .get("GetBodForm", { params: params })
            .then((res) => {
                const rawData = res.data;
                const data = normalizeKeys(rawData);

                const existingForm = data.EXISTINGFORM;
                if (existingForm) {
                    setForm((prev) => ({
                        ...prev,
                        ...existingForm,
                        PAKET_NO: existingForm.PAKET_NO || "",
                        FIS_NO: existingForm.FIS_NO || prev.FIS_NO
                    }));

                    if (existingForm.PAKET_NO && !existingForm.FIS_NO) {
                        setEntryType("PAKET");
                    }
                }

                setBodList(data.BODCOMPANIES || []);
            })
            .catch((err) => logger.error("GetBodForm error:", err));

    }, [effectiveFisNo]);

    //MODEL FİLTRELEME
    useEffect(() => {
        if (!allModeller.length) return;
        const filtered = allModeller.filter(m => {
            const searchText = modelSearch.toLocaleLowerCase("tr-TR");
            const modelName = (m.KUL_MODEL_KODU + " " + m.ACIKLAMA).toLocaleLowerCase("tr-TR");
            return modelName.includes(searchText);
        }).slice(0, 15);
        setFilteredModeller(filtered);
    }, [modelSearch, allModeller]);

    //BAYİ FİLTRELEME
    useEffect(() => {
        if (!allBayiler.length) return;
        const filtered = allBayiler.filter(b => {
            const searchText = bayiSearch.toLocaleLowerCase("tr-TR");
            const bayiName = (b.KUL_BAYI_KODU + " " + b.ACIKLAMA).toLocaleLowerCase("tr-TR");
            const textMatch = bayiName.includes(searchText);

            let markaMatch = true;
            if (selectedModelMarka) {
                const bayiMarka = Number(b.MARKA_KODU);
                if (selectedModelMarka === 3) markaMatch = (bayiMarka === 3);
                else if (selectedModelMarka === 4) markaMatch = (bayiMarka === 4);
            }
            return textMatch && markaMatch;
        }).slice(0, 15);
        setFilteredBayiler(filtered);
    }, [bayiSearch, allBayiler, selectedModelMarka]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    const handleEntryTypeChange = (e) => {
        // Eğer URL'den fiş no geldiyse değişimi engelle
        if (isUrlHasFis) return;

        const newVal = e.target.value;
        setEntryType(newVal);

        // Tip değişince diğer inputu temizle
        if (newVal === "FIS") {
            setForm({ ...form, PAKET_NO: "" });
        } else {
            setForm({ ...form, FIS_NO: "" });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        const payload = { ...form };

        if (entryType === "FIS") {
            payload.PAKET_NO = null;
        } else {
            payload.FIS_NO = null;
        }

        try {
            const res = await axios.post("SetBodForm", payload);
            if (!res.data) {
                setSnackbar({ open: true, message: "Form başarıyla kaydedildi!", severity: "success" });
                return;
            }
            if (res.data.ErrorCode === "0") {
                setSnackbar({ open: true, message: res.data.ErrorDescription || "Form başarıyla kaydedildi!", severity: "success" });
                // window.location.reload(); // Başarılı ise sayfayı yenile
                resetForm();
            } else {
                setSnackbar({ open: true, message: res.data.ErrorDescription || "Bir hata oluştu!", severity: "error" });
            }
        } catch (err) {
            setSnackbar({ open: true, message: "Beklenmeyen hata: " + err.message, severity: "error" });
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (entryType === "FIS") {
            if (!form.FIS_NO) newErrors.FIS_NO = "Fiş Numarası veya Bayi İş Emri Numarası girilmesi zorunludur.";
        } else {
            if (!form.PAKET_NO) newErrors.PAKET_NO = "Fiş Numarası veya Bayi İş Emri Numarası girilmesi zorunludur.";
        }

        if (!form.KUL_BAYI_KODU) newErrors.KUL_BAYI_KODU = "Yetkili satıcı seçimi zorunludur.";
        if (!form.KUL_MODEL_KODU) newErrors.KUL_MODEL_KODU = "Ürün modeli seçimi zorunludur.";
        if (!form.TUKETICI_AD_SOYAD) newErrors.TUKETICI_AD_SOYAD = "Tüketici adı soyadı zorunludur.";
        if (!form.TUKETICI_TELEFON) newErrors.TUKETICI_TELEFON = "Telefon numarası zorunludur.";
        if (form.TUKETICI_TELEFON && form.TUKETICI_TELEFON.length !== 11) newErrors.TUKETICI_TELEFON = "Telefon numarası 11 haneli olmalıdır.";
        if (!form.UYIL) {
            newErrors.UYIL = "Üretim yılı zorunludur.";
        } else if (String(form.UYIL).length !== 4) {
            newErrors.UYIL = "Üretim yılı 4 haneli olmalıdır.";
        }
        if (!form.UDONEM) newErrors.UDONEM = "Üretim ayı zorunludur.";
        if (!form.SERI_NO) newErrors.SERI_NO = "Seri numarası zorunludur.";
        if (!form.NITELIK_KODU) newErrors.NITELIK_KODU = "Nitelik kodu zorunludur."
        if (!form.ACIKLAMA) newErrors.ACIKLAMA = "Açıklama alanı zorunludur.";
        if (!form.BOD_ADI) newErrors.BOD_ADI = "BOD şirketi seçilmelidir.";
        if (!form.BOD_CALISAN_AD_SOYAD) newErrors.BOD_CALISAN_AD_SOYAD = "BOD çalışan adı zorunludur.";
        if (!form.BOD_ARAC_PLAKA) {
            newErrors.BOD_ARAC_PLAKA = "Araç plakası zorunludur.";
        } else {
            const hasLetter = /[a-zA-ZçÇğĞıİöÖşŞüÜ]/.test(form.BOD_ARAC_PLAKA);
            const hasNumber = /[0-9]/.test(form.BOD_ARAC_PLAKA);
            if (!hasLetter || !hasNumber) {
                newErrors.BOD_ARAC_PLAKA = "Formda eksik veya hatalı bilgiler mevcut, kontrol ediniz!";
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    return (
        <>
            <Paper
                elevation={0}
                style={{
                    padding: "40px 48px",
                    maxWidth: 1000,
                    margin: "0 auto 20px auto",
                    borderRadius: 0,
                    backgroundColor: "#fff",
                }}
            >
                <Typography
                    variant="h6"
                    align="center"
                    style={{ color: "#000000ff", marginBottom: 24, fontWeight: 600 }}
                >
                    Bayi Ortak Depodan (BOD) Gelen Ürünler için Genel Amaçlı Tutanak
                </Typography>

                <form noValidate onSubmit={handleSubmit}>
                    <Grid container spacing={3}>

                        <Grid item xs={12}>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Giriş Türü Seçiniz</FormLabel>
                                <RadioGroup
                                    row
                                    name="entryType"
                                    value={entryType}
                                    onChange={handleEntryTypeChange}
                                >
                                    <FormControlLabel
                                        value="FIS"
                                        control={<Radio color="primary" />}
                                        label="Fiş Numarası"
                                        disabled={isUrlHasFis} // URL'den geldiyse kilitli
                                    />
                                    <FormControlLabel
                                        value="PAKET"
                                        control={<Radio color="primary" />}
                                        label="Bayi İş Emri Numarası"
                                        disabled={isUrlHasFis}
                                    />
                                </RadioGroup>
                            </FormControl>
                        </Grid>

                        {entryType === "FIS" && (
                            <Grid item xs={12}>
                                <TextField
                                    label="Fiş Numarası"
                                    name="FIS_NO"
                                    fullWidth
                                    variant="outlined"
                                    value={form.FIS_NO || ""}
                                    onChange={(e) => {
                                        // Eğer URL'den geldiyse değiştirmeye izin verme
                                        if (isUrlHasFis) return;
                                        const val = e.target.value.replace(/\D/g, "").slice(0, 10);
                                        setForm({ ...form, FIS_NO: val });
                                    }}
                                    disabled={isUrlHasFis}
                                    error={Boolean(errors.FIS_NO)}
                                    helperText={errors.FIS_NO}
                                    inputProps={{ maxLength: 10 }}
                                />
                            </Grid>
                        )}

                        {entryType === "PAKET" && (
                            <Grid item xs={12}>
                                <TextField
                                    label="Bayi İş Emri Numarası"
                                    name="PAKET_NO"
                                    fullWidth
                                    variant="outlined"
                                    value={form.PAKET_NO || ""}
                                    onChange={(e) => {
                                        const val = e.target.value.replace(/\D/g, "").slice(0, 10);
                                        setForm({ ...form, PAKET_NO: val });
                                    }}
                                    error={Boolean(errors.PAKET_NO)}
                                    helperText={errors.PAKET_NO}
                                    inputProps={{ maxLength: 10 }}
                                />
                            </Grid>
                        )}


                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="İş Emrindeki/Sevk İrsaliyesindeki Tüketici Adı Soyadı"
                                name="TUKETICI_AD_SOYAD"
                                fullWidth
                                variant="outlined"
                                value={form.TUKETICI_AD_SOYAD || ""}
                                onChange={handleChange}
                                error={Boolean(errors.TUKETICI_AD_SOYAD)}
                                helperText={errors.TUKETICI_AD_SOYAD}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="İş Emrindeki/Sevk İrsaliyesindeki Tüketici Telefon Numarası"
                                name="TUKETICI_TELEFON"
                                fullWidth
                                variant="outlined"
                                value={form.TUKETICI_TELEFON || ""}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\D/g, "");
                                    setForm({ ...form, TUKETICI_TELEFON: value });
                                }}
                                inputProps={{ maxLength: 11 }}
                                error={Boolean(errors.TUKETICI_TELEFON)}
                                helperText={errors.TUKETICI_TELEFON}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Autocomplete
                                options={filteredBayiler}
                                getOptionLabel={(option) => `${option.KUL_BAYI_KODU || ""} - ${option.ACIKLAMA || ""}`}
                                value={allBayiler.find((b) => b.KUL_BAYI_KODU === form.KUL_BAYI_KODU) || null}
                                onInputChange={(e, value) => setBayiSearch(value)}
                                onChange={(e, value) => {
                                    setForm({ ...form, KUL_BAYI_KODU: value?.KUL_BAYI_KODU || "" });
                                }}
                                filterOptions={(x) => x}
                                renderInput={(params) => (
                                    <TextField {...params}
                                        label="Yetkili Satıcı"
                                        variant="outlined"
                                        fullWidth
                                        error={Boolean(errors.KUL_BAYI_KODU)}
                                        helperText={errors.KUL_BAYI_KODU}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Autocomplete
                                options={filteredModeller}
                                getOptionLabel={(option) => `${option.KUL_MODEL_KODU || ""} - ${option.ACIKLAMA || ""}`}
                                value={allModeller.find((m) => m.KUL_MODEL_KODU === form.KUL_MODEL_KODU) || null}
                                onInputChange={(e, value) => setModelSearch(value)}
                                onChange={(e, value) => {
                                    const marka = value?.MARKA_KODU ? Number(value.MARKA_KODU) : null;
                                    setSelectedModelMarka(marka);
                                    setForm({
                                        ...form,
                                        KUL_MODEL_KODU: value?.KUL_MODEL_KODU || "",
                                        KUL_BAYI_KODU: ""
                                    });
                                    setBayiSearch("");
                                }}
                                filterOptions={(x) => x}
                                renderInput={(params) => (
                                    <TextField {...params}
                                        label="Ürün Modeli"
                                        variant="outlined"
                                        fullWidth
                                        error={Boolean(errors.KUL_MODEL_KODU)}
                                        helperText={errors.KUL_MODEL_KODU}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="BOD'dan Fiili Olarak Gelen Ürün Üretim Yılı"
                                name="UYIL"
                                variant="outlined"
                                fullWidth
                                inputProps={{ maxLength: 4 }}
                                value={form.UYIL || ""}
                                onChange={(e) => {
                                    const val = e.target.value.replace(/\D/g, "").slice(0, 4);
                                    setForm({ ...form, UYIL: val });
                                }}
                                error={Boolean(errors.UYIL)}
                                helperText={errors.UYIL}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth variant="outlined" error={Boolean(errors.UDONEM)}>
                                <InputLabel>Ürün Üretim Ayı</InputLabel>
                                <Select
                                    name="UDONEM"
                                    value={form.UDONEM || ""}
                                    onChange={handleChange}
                                    label="Ürün Üretim Ayı"
                                >
                                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((val) => (
                                        <MenuItem key={val} value={val}>{val}</MenuItem>
                                    ))}
                                </Select>
                                {errors.UDONEM && <div style={{ color: "#f44336", fontSize: "0.75rem", marginTop: 3 }}>{errors.UDONEM}</div>}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="BOD'dan Fiili Olarak Gelen Ürün Seri No"
                                name="SERI_NO"
                                variant="outlined"
                                fullWidth
                                value={form.SERI_NO || ""}
                                onChange={(e) => {
                                    const numeric = e.target.value.replace(/\D/g, "");
                                    setForm({ ...form, SERI_NO: numeric ? parseInt(numeric, 10) : null });
                                }}
                                error={Boolean(errors.SERI_NO)}
                                helperText={errors.SERI_NO}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth variant="outlined" error={Boolean(errors.NITELIK_KODU)}>
                                <InputLabel>Nitelik Kodu</InputLabel>
                                <Select
                                    name="NITELIK_KODU"
                                    value={form.NITELIK_KODU || ""}
                                    onChange={handleChange}
                                    label="Nitelik Kodu"
                                >
                                    <MenuItem value={1}>Normal</MenuItem>
                                    <MenuItem value={2}>Revizyonlu (Yeniden Değerlendirilmiş)</MenuItem>
                                </Select>
                                {errors.NITELIK_KODU && <div style={{ color: "#f44336", fontSize: "0.75rem", marginTop: 3 }}>{errors.NITELIK_KODU}</div>}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                label="Tespit Edilen Sorun veya Hasar Açıklaması"
                                name="ACIKLAMA"
                                variant="outlined"
                                fullWidth
                                multiline
                                rows={3}
                                value={form.ACIKLAMA || ""}
                                onChange={handleChange}
                                error={Boolean(errors.ACIKLAMA)}
                                helperText={errors.ACIKLAMA}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth variant="outlined" error={Boolean(errors.BOD_ADI)}>
                                <InputLabel>Bayi Ortak Depo (BOD) Adı</InputLabel>
                                <Select
                                    name="BOD_ADI"
                                    value={form.BOD_ADI || ""}
                                    onChange={handleChange}
                                    label="Bayi Ortak Depo (BOD) Adı"
                                >
                                    {bodList.map((b) => (
                                        <MenuItem key={b.DEPO_KODU} value={b.DEPO_KODU}>
                                            {b.DEPO_KODU}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {errors.BOD_ADI && <div style={{ color: "#f44336", fontSize: "0.75rem", marginTop: 3 }}>{errors.BOD_ADI}</div>}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="BOD Çalışanı Adı Soyadı"
                                name="BOD_CALISAN_AD_SOYAD"
                                variant="outlined"
                                fullWidth
                                value={form.BOD_CALISAN_AD_SOYAD || ""}
                                onChange={handleChange}
                                error={Boolean(errors.BOD_CALISAN_AD_SOYAD)}
                                helperText={errors.BOD_CALISAN_AD_SOYAD}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Nakliye / Lojistik Aracı Plakası"
                                name="BOD_ARAC_PLAKA"
                                variant="outlined"
                                fullWidth
                                value={form.BOD_ARAC_PLAKA || ""}
                                onChange={handleChange}
                                error={Boolean(errors.BOD_ARAC_PLAKA)}
                                helperText={errors.BOD_ARAC_PLAKA}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Nakliye veya Montaj Fiş No (Varsa)"
                                name="NAKLIYE_MONTAJ_FIS_NO"
                                variant="outlined"
                                fullWidth
                                value={form.NAKLIYE_MONTAJ_FIS_NO || ""}
                                onChange={(e) => {
                                    const numeric = e.target.value.replace(/\D/g, "").slice(0, 10);
                                    setForm({ ...form, NAKLIYE_MONTAJ_FIS_NO: numeric || null });
                                }}
                                inputProps={{ maxLength: 10 }}
                            />
                        </Grid>

                        <Grid item xs={12} style={{ textAlign: "center", marginTop: 16 }}>
                            <Button
                                variant="contained"
                                color="primary"
                                type="submit"
                                size="large"
                                style={{ padding: "10px 48px", borderRadius: 8, fontWeight: 600, backgroundColor: "#fb7900ff", color: "#fff" }}
                            >
                                Tamamla ve Gönder
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Paper>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <MuiAlert
                    elevation={6}
                    variant="filled"
                    severity={snackbar.severity}
                    onClose={() => setSnackbar({ ...snackbar, open: false })}
                >
                    {snackbar.message}
                </MuiAlert>
            </Snackbar>
        </>
    );
};

export default BodForm;